import { PersonasRepository } from '../../domain/repositories/personas.repository';
import { personasRepository } from '../repositories/personas.respository';

export const personasRepositoryInstance: PersonasRepository = personasRepository();
